var _scrollAtEnd;

import { createContext } from 'react';
import { StickTo } from '../../Table.decl';
export var TableRootContext = /*#__PURE__*/createContext({
  horizontallyScrollableContainerRef: undefined,
  loading: false,
  recordAttributeIdentifier: 'id',
  scrollAtEnd: (_scrollAtEnd = {}, _scrollAtEnd[StickTo.Left] = false, _scrollAtEnd[StickTo.Right] = false, _scrollAtEnd)
});